var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('style',{tag:"component"},[_vm._v("\n  :root {\n  --speed: target "+_vm._s(_vm.speed)+"s;\n  }\n")])}
var staticRenderFns = []

export { render, staticRenderFns }